import {get} from '@acng/frontend-bounty/dom/attribute.js';
import {CLICK, off, on} from '@acng/frontend-bounty/dom/event.js';
import {guard, IS_ELEMENT} from '@acng/frontend-rubicon';
import {AttributeLink} from '@acng/frontend-stargazer';
import {ONCLICK_TARGET} from './onclick-target';
import {Matcher} from '@acng/frontend-bounty/dom/element.js';
import {goBack} from 'acng/core/service/location';

/**
 * @group DOM Attribute
 */
const name = 'onclick-history-back';

AttributeLink(name, (element, value) => {
  const isEnabled = Matcher(get(element, ONCLICK_TARGET));

  /**
   * @param {MouseEvent} evt
   */
  const click = ({target}) => {
    ASSERT: guard(target, IS_ELEMENT);

    if (!isEnabled(target)) {
      return;
    }

    goBack(value);
  };

  return () => (on(element, CLICK, click), () => off(element, CLICK, click));
});

export {name as ONCLICK_HISTORY_BACK};
